import { Link } from "react-router-dom";
import "./request-product-cta.css";

export default function RequestProductCTA({
    title = "Didn't find an item?",
    description = "Want something we don’t have? Request it here, and we’ll bring it to you as soon as possible!",
    buttonText = "Request Product",
    imageSrc = "/icons/add-product.png",
    linkTo = "/request-product"
}) {
    return (
        <div className="footer-section">
            <div className="footer-content">
                <p className="footer-title">{title}</p>

                <p className="footer-subtitle">
                    {description}
                </p>

                <Link
                    to={linkTo}
                    className="footer-request-link"
                >
                    <div className="footer-request-btn">
                        {buttonText}
                    </div>
                </Link>
            </div>

            {
                imageSrc && (
                    <div className="footer-image-box">
                        <img
                            src={imageSrc}
                            alt="Request Product"
                            className="footer-image"
                        />
                    </div>
                )
            }
        </div>
    );
}